import { LocalizationModel } from './localization.model';
import { LocalizationType } from './localization.type';

export const LocalizationTranslationConst: LocalizationModel = {
  [LocalizationType.KZ]: 'Қаз',
  [LocalizationType.RU]: 'Рус',
  [LocalizationType.EN]: 'Eng',
};

export const LAST_SELECTED_LANG_KEY = 'lastSelectedLang';
